import classNames from "classnames";
import i18next from "i18next";
import { BsChevronDown } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

import { useToggle } from "../../../hooks";
import { resetFilters } from "../../../store/resultFiltersSlice";

import FilterBlockComponent from "../FilterBlockComponent";

import { FiltersBlock, FiltersButton, FiltersHeader, FiltersTitle, IconBlock, ResetButton, Wrapper } from "./style";

const FiltersComponent = () => {
  const { t } = i18next;
  const { isTrue, toggle } = useToggle();
  const { filterParams } = useSelector(state => state.resultFilters);
  const dispatch = useDispatch();

  // FE-14: сбрасывать нечего, пока ни один фильтр не тронут.
  // Сортировка фильтром не считается — она живёт табами над списком.
  const hasActiveFilters = Object.entries(filterParams).some(
    ([type, param]) => type !== "sorting" && param?.isActive
  );

  return (
    <Wrapper>
      <FiltersButton onClick={toggle}>
        {t("filters")}
        <IconBlock className={classNames({ active: isTrue })}>
          <BsChevronDown />
        </IconBlock>
      </FiltersButton>

      <FiltersBlock className={classNames({ active: isTrue })}>
        <FiltersHeader>
          <FiltersTitle>{t("filters")}</FiltersTitle>
          {hasActiveFilters && (
            <ResetButton type="button" onClick={() => dispatch(resetFilters())}>
              {t("reset_filters")}
            </ResetButton>
          )}
        </FiltersHeader>

        <FilterBlockComponent />
      </FiltersBlock>
    </Wrapper>
  );
};

export default FiltersComponent;
